(function () {
  'use strict';

  angular.module('wsLrs.controllers').
  //esFilters and title are passed in via modal.open
  controller('AnswersModalCtrl', ['$scope', '$uibModalInstance', 'Api', '$http', 'cardId', 'downloadUrl', 'questionId', 'TinCanJS', 'title', '$location', function ($scope, $uibModalInstance, Api, $http, cardId, downloadUrl, questionId, TinCanJS, title, $location) {
    var maxStatements = 100;

    //break down the downloadUrl to find the filter
    var urlParts = downloadUrl.split("filters=");
    if (urlParts.length > 1) {
      var params = urlParts[1].split("&");
      var filter = JSON.parse(decodeURIComponent(params[0]));

      //add question id to downloadUrl filter
      filter = {
        and: [filter, {
          activityIds: {
            ids: [questionId]
          }
        }]
      };

      //put the downloadUrl back together
      params[0] = encodeURIComponent(JSON.stringify(filter));
      urlParts[1] = params.join("&");
      downloadUrl = urlParts.join("filter=");
    }
    $scope.downloadUrl = downloadUrl;
    $scope.title = title;
    $scope.statementLimit = maxStatements;
    $scope.isModal = true;
    $scope.closeModal = function () {
      $uibModalInstance.dismiss();
    };
    var config = {
      params: {
        questionId: questionId || {},
        cardId: cardId,
        filter: $location.search().filter
      }
    };
    $http.get(Api.url("/interactions/question-stream"), config).then(function (response) {
      var statements = response.data.results[0].result;
      $scope.statements = TinCanJS.getExtendedDecoratedStatements(statements);
      _.each($scope.statements, function (s) {
        s.originalObjectName = s.objectName;
        s.objectName = 'this question';
      });
      $scope.totalStatements = response.data.totalHits;
      $scope.additionalStatements = $scope.totalStatements - $scope.statements.length;
    });
  }]);
})();
